import { mapGetters } from 'vuex';
import ProductDetailsSimplified from "./ProductDetailsSimplified";
import Accounting from '../../mixins/accounting';
import { setUpdateBooking } from "../../vuex/quotes/actions";
import { getModification } from "../../vuex/quotes/getters";
import VehicleCardLocalisations from "../../lang/VehicleCard";
import branding from '../../mixins/branding';

require('./scss/product-upsell.scss');

export default {
    props: [
        'product',
        'title',
        'icon',
        'isDisabled',
        'labels',
        'showTermsAndConditions',
        'upsellCardType',
        'upgradeService',
        'setEditing',
        'upsellModalVisible',
        'basicProductId',
        'setType'
    ],
    mixins: [Accounting, branding],

    i18n: VehicleCardLocalisations,

    components: {
        ProductDetailsSimplified,
    },
    data() {
        return {
            authenticated: window.greenmotion.authenticated || false,
            checked: this.requireCheckedIcon(),
            unchecked: this.requireUncheckedIcon(),
            icons: {
                PLU: this.brandingImagesPath("/images/vehicle-listing/plus-badge.svg"),
                PRE: this.brandingImagesPath("/images/vehicle-listing/premium-badge.svg"),
                PMP: this.brandingImagesPath("/images/vehicle-listing/premium-plus-badge.svg")
            },
        }
    },
    template: `
        <div v-if="product" @click="chooseProduct(product)" :class="[{'product-upsell--disabled': isDisabled},productUpsellClass(product),productUpsellCardType, {'position-relative': productUpsellCardType !== 'product-upsell'}]">
            <div 
                :class="[
                    'inner d-flex flex-column justify-content-between',
                    { 'product-upsell--highlighted': product.type === 'PMP'},
                    { 'selected': chosenProductToDisplay }
                ]
                "
            >
                <div class="product-upsell-main position-relative">
                    <h5 class="title text-center mb-4 mt-3"><img :src="icons[product.type]" alt=""></h5>

                    <h4 class="title upsell-title text-capitalize">{{ title }}</h4>
                    <product-details-simplified
                      :showTermsAndConditions="showTermsAndConditions"
                      :product="product"
                      :upsell-card-type="productUpsellCardType"
                      :class="{'product-details--highlighted': product.type === 'PMP' && !usBookingMobile }"
                    ></product-details-simplified>
                </div>
                <div v-if="!usBookingMobile" class="product-upsell__footer">
                    <span class="product-upsell__range">
                        <img :src="icon" alt=""/>
                        {{ labels.quoteHireLength }}
                    </span>
                    <div class="product-upsell__selection">
                        <div v-if="product.total_price >= selectedProduct.total_price"  class="total">
                            &plus;&nbsp;{{ selectedPriceDiffBasePrice(selectedProduct, product, this.quoteHireDuration) }} <small>{{ labels.extraPerDay }}</small>
                        </div>
                        <div v-else  class="total">
                            &minus;&nbsp;{{ selectedPriceDiffBasePrice(selectedProduct, product, this.quoteHireDuration) }} <small>{{ labels.extraPerDay }}</small>
                        </div>
                        <span v-if="!isDisabled"  class="checkRound">
                            <img svg-inline :src="checkmark">
                        </span>
                    </div>
                </div>

                <div
                    v-else-if="(upsellCardType === 'edit-booking' && authenticated || upsellCardType !== 'edit-booking') && !isRouteTypeGuest" 
                     class="product-upsell-footer"
                >
                    <template>
                      <button
                        v-if="upsellCardType !== 'edit-booking' || this.upsellCardType === 'edit-booking' && !chosenProductToDisplay"
                        :class="['btn mb-2',{'editing': upsellCardType === 'edit-booking'},{'btn-link-outline': product.type !== 'PMP'},{'btn-solid': product.type === 'PMP'},'w-100 py-4']"
                        :disabled="isDisabled && upsellCardType === 'edit-booking'"
                        data-dismiss="modal"
                      >
                        {{ $t('VehicleCard.upgrade') }}
                      </button>
                      <button
                        v-if="this.upsellCardType === 'edit-booking' && chosenProductToDisplay"
                        :class="['btn mb-2',{'editing': upsellCardType === 'edit-booking'},{'btn-link-outline': product.type !== 'PMP'},{'btn-solid': product.type === 'PMP'},'w-100 py-4']"
                        :disabled="isDisabled && upsellCardType === 'edit-booking'"
                        data-dismiss="modal"
                      >
                        {{ $t('VehicleCard.cancel_upgrade') }}
                      </button>
                    
                        <div v-if="product.total_price >= selectedProduct.total_price"  class="total text-center">
                            &plus;&nbsp;<b>{{ selectedPriceDiffBasePrice(selectedProduct, product, this.quoteHireDuration) }}</b> <small>{{ labels.extraPerDay }}</small>
                        </div>
                        <div v-else  class="total text-center">
                            &minus;&nbsp;<b>{{ selectedPriceDiffBasePrice(selectedProduct, product, this.quoteHireDuration) }}</b> <small>{{ labels.extraPerDay }}</small>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    `,
    computed: {
        ...mapGetters({
            quote: 'getQuote',
            selectedCurrency: 'selectedCurrency',
            selectedVehicle: 'getSelectedVehicle',
            selectProduct: 'getSelectedVehicleProduct',
            quoteHireDuration: 'quoteHireDuration',
            extras: 'getExtras',
            selectedExtras: 'getSelectedExtras',
            editing: 'getBookingUpdateStatus',
            booking: 'getBooking',
            modification: 'getModification',
        }),
        isRouteTypeGuest() {
            return this.$router?.currentRoute?.meta?.userType === 'guest';
        },
        chosenProductToDisplay() {
            return ((this.modification?.rental_code === '' || this.modification?.errors) && (this.selectedProduct.type === this.product.type)
                || this.modification?.rental_code !== '' && (this.modification?.rental_code === this.product.type));
        },
        isUSSource() {
            if (this.selectedVehicle?.charges || this.quote?.us_location) {
                return true;
            }
            return false;
        },
        selectedProduct() {
            return this.selectProduct;
        },
        checkmark() {
            if (this.selectedProduct.id === this.product.id) {
                return this.checked;
            }

            return this.unchecked;
        },
        productUpsellCardType() {
            if (this.usBookingMobile) {
                if (this.modification?.rental_code === '' && this.selectedProduct.id === this.product.id) {
                    return 'us-product-selected'
                }
                return 'us-product-upsell';
            }
            return 'product-upsell';
        },
        usBookingMobile() {
            return !!(this.upsellCardType && (this.upsellCardType === 'us-source-booking' || this.upsellCardType === 'edit-booking'));
        },
    },
    methods: {
        productUpsellClass(product) {
            return `product-upsell--${product.type}`;
        },
        chooseProduct(product) {
            const quoteId = this.quote.id;
            const originalId = this.booking ? this.booking.quote_id : null;

            let productId = this.selectedProduct.type === product.type
            && this.upsellCardType === 'edit-booking'
                ? this.basicProductId
                : product.id;

            if (typeof this.setType !== 'undefined') {
                this.setType(product.type);
            }

            const isPartialModification = (typeof this.quote.id !== 'undefined' && typeof this.booking !== 'undefined' && (this.quote.id === this.booking.quote_id));

            if ((typeof this.$route !== 'undefined' && this.$route.params.booking) && isPartialModification) {
                if (product.type === this.modification?.rental_code || this.selectedProduct?.type === product.type) {
                    productId = this.selectedProduct.id;
                }

                this.$store.dispatch('updateVehicleWithBooking', {
                    selectedVehicle: this.selectedVehicle,
                    productId: productId,
                    bookingId: this.booking.id,
                    bookingReference: this.booking.reference,
                    quoteId: quoteId,
                });
            } else {
                this.$store.dispatch('updateVehicle', {
                    selectedVehicle: this.selectedVehicle,
                    productId: productId,
                    quoteId: quoteId,
                })
                    .then((response) => {
                        if (originalId !== null) {
                            this.$store.dispatch('copyUpdateExtras', { quoteId, originalId });

                            this.$store.dispatch('fetchTotals', quoteId)
                                .then((response) => {

                                });

                            if (product.type !== 'BAS' || this.isUSSource) {
                                this.$store.dispatch('setUpdateBooking', true);
                            } else {
                                this.$store.dispatch('setUpdateBooking', false);
                            }
                        }
                    })
                    .catch(error => {
                        this.$store.dispatch('createError', error);
                    });
            }

            if (this.upsellModalVisible) {
                this.upsellModalVisible(false);
            }
        }
    },
    mounted() {
        if (this.$route.params.booking) {
            const bookingId = this.$route.params.booking;

            this.$store
              .dispatch("fetchBooking", bookingId)
              .catch((error) => console.log(error));
        }
    },
}
